import { Box, Button, CircularProgress } from "@mui/material";
import { useContext } from "react";
import { useTranslation } from "react-i18next";

import { APIKeyManagementContent } from "pages/Corporate/APIKeyManagement/APIKeyManagement.view";
import { CorporateContext } from "contexts/CorporateContext/CorporateContext";
import { ApiAdminLayout } from "../components/ApiAdminLayout";
import { useStyles } from "./ApiKeysPage.styles";

/**
 * The API Administrator portal's only page (OS-2557). Same body the Corporate Admin sees at
 * /corporate_backoffice/api_key_management, rendered in the portal's minimal chrome.
 *
 * The body is held back until the profile query settles. APIKeyManagementContent's enable-gate
 * (useAllowApiKeyManagement) derives its permission from CorporateContext.currentUser, so mounting
 * it while the profile is still unknown makes it render the "API access is not available for your
 * organization" copy — a false reason, and on this portal it is the role's entire product surface.
 * A profile that fails or returns no row gets an explicit retry instead of that same message.
 */
export const ApiKeysPage = () => {
    const { t } = useTranslation();
    const classes = useStyles();
    const { currentUser, isLoadingCurrentUser, refreshCurrentUser } = useContext(CorporateContext);

    const renderBody = () => {
        if (isLoadingCurrentUser) {
            return (
                <Box className={classes.statusWrapper}>
                    <CircularProgress />
                </Box>
            );
        }

        if (!currentUser) {
            return (
                <Box className={classes.statusWrapper}>
                    <span className={classes.statusMessage}>{t("api_administration.profile_unavailable")}</span>
                    <Button variant="outlined" onClick={() => refreshCurrentUser()}>
                        {t("api_administration.retry")}
                    </Button>
                </Box>
            );
        }

        return <APIKeyManagementContent />;
    };

    return <ApiAdminLayout>{renderBody()}</ApiAdminLayout>;
};
